'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { type FilterDimension, type FilterValue, SortFilterBar } from '@/components/shared/sort-filter-bar';
import { AnimatedSwitch } from '@/components/ui/animated-switch';
interface ProposalFeedToolbarProps {
  sortOptions: ComponentProps<typeof SortFilterBar>['sortOptions'];
  activeSort: string;
  onSortChange: (value: string) => void;
  onSortEvent: (value: string) => void;
  filters: FilterDimension[];
  activeFilters: Record<string, FilterValue | undefined>;
  onFilterChange: (key: string, value: FilterValue) => void;
  onClearAll: () => void;
  isAuthenticated: boolean;
  isMyProposals: boolean;
  onMyProposalsChange: (next: boolean) => void;
  filterOpen: boolean;
  onFilterOpenChange: (open: boolean) => void;
}

/**
 * Sort + filter toolbar for the proposal feed. Wraps the shared
 * `SortFilterBar`, supplying the launchpad i18n labels and the authenticated
 * "My Proposals" toggle as `topContent`. Purely presentational — all state and
 * analytics live in the parent `ProposalFeed`.
 */
export function ProposalFeedToolbar(t0) {
  const $ = _c(38);
  const {
    sortOptions,
    activeSort,
    onSortChange,
    onSortEvent,
    filters,
    activeFilters,
    onFilterChange,
    onClearAll,
    isAuthenticated,
    isMyProposals,
    onMyProposalsChange,
    filterOpen,
    onFilterOpenChange
  } = t0;
  const t = useTranslations("launchpad.feed");
  const tFilters = useTranslations("filters");
  let t1;
  if ($[0] !== tFilters) {
    t1 = tFilters("sheetTitleProposals");
    $[0] = tFilters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== tFilters) {
    t2 = tFilters("clearAll");
    $[2] = tFilters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("filterButton");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== tFilters) {
    t4 = tFilters("close");
    $[6] = tFilters;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== tFilters) {
    t5 = tFilters("reset");
    $[8] = tFilters;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== tFilters) {
    t6 = tFilters("showResults");
    $[10] = tFilters;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== tFilters) {
    t7 = count => tFilters("nSelected", {
      count
    });
    $[12] = tFilters;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isAuthenticated || $[15] !== isMyProposals || $[16] !== onMyProposalsChange || $[17] !== t) {
    t8 = isAuthenticated ? <div className="flex items-center justify-between gap-3 border-border-secondary border-b pb-4"><span className="text-body font-medium text-foreground-primary">{t("myProposals")}</span><AnimatedSwitch checked={isMyProposals} onCheckedChange={onMyProposalsChange} aria-label={t("myProposals")} /></div> : undefined;
    $[14] = isAuthenticated;
    $[15] = isMyProposals;
    $[16] = onMyProposalsChange;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== activeFilters || $[20] !== activeSort || $[21] !== filterOpen || $[22] !== filters || $[23] !== onClearAll || $[24] !== onFilterChange || $[25] !== onFilterOpenChange || $[26] !== onSortChange || $[27] !== onSortEvent || $[28] !== sortOptions || $[29] !== t1 || $[30] !== t2 || $[31] !== t3 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8) {
    t9 = <div className="flex items-start gap-2"><div className="flex-1 min-w-0"><SortFilterBar sortOptions={sortOptions} activeSort={activeSort} onSortChange={onSortChange} filters={filters} activeFilters={activeFilters} onFilterChange={onFilterChange} onClearAll={onClearAll} filterSheetTitle={t1} clearAllLabel={t2} filterButtonLabel={t3} closeLabel={t4} resetLabel={t5} applyLabel={t6} selectedCountLabel={t7} onSortEvent={onSortEvent} topContent={t8} filterOpen={filterOpen} onFilterOpenChange={onFilterOpenChange} hideInlineSettings={true} /></div></div>;
    $[19] = activeFilters;
    $[20] = activeSort;
    $[21] = filterOpen;
    $[22] = filters;
    $[23] = onClearAll;
    $[24] = onFilterChange;
    $[25] = onFilterOpenChange;
    $[26] = onSortChange;
    $[27] = onSortEvent;
    $[28] = sortOptions;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  return t9;
}